import { Facade } from '@/modules/budget/monitoring/input-forms/types/roots/Facade';
import { FilterSettingsForm } from '@/modules/budget/monitoring/input-forms/types/roots/FilterSettingsForm';
import { App26FilterSettingsForm } from './app26InputForm';

export class App26InputFormFacade implements Facade {
    public saveData: (() => Promise<void>) | null = null;
    public updateBp: (() => Promise<void>) | null = null;
    public downloadList: { name: string; fn: (...args: any[]) => void; args: any[]; idx: number }[] = [];
    public onBackFn: (() => Promise<boolean>) | null = null;

    async onBack(): Promise<boolean> {
        if (this.onBackFn) return await this.onBackFn();
        return true;
    }

    getFilterSettings(): FilterSettingsForm {
        const form: App26FilterSettingsForm = {
            user_id: '',
            edit_access: false,
            delete_access: false,
            convert: 1000,
            application: null,
            child_status: null,
            prg: null,
        };
        return form;
    }
}
